<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog v-if="isView" v-model="isView" persistent scrollable width="800">
        <v-card class="mt-3 pa-1">
            <v-card-title class="pa-0">
                <v-app-bar dense color="primary" dark elevation="0">
                    <v-list-item-title>
                        <v-icon>mdi-eye-circle</v-icon>                                                
                        <span>観察</span>
                    </v-list-item-title>
                    <TitleButton
                        v-if="!readOnly"
                        @click="onClickSave"
                        color="primary"
                        icon="mdi-floppy"
                        name="保存" />
                    <!-- <TitleButton
                        color="primary"
                        icon="mdi-pencil"
                        name="編集" /> -->
                    <TitleButton
                        color="primary"
                        icon="mdi-close-circle"
                        name="閉じる"
                        @click="isView = false" />
                </v-app-bar>
            </v-card-title>
            <v-card-text style="height:700px" class="pa-0">
                <v-container>
                    <!-- 編集用 -->
                    <v-form ref="form" >
                        <v-row dense>
                            <v-col>
                                <DatePicker 
                                    label="作業日"
                                    v-model="editItems.date"
                                    dense
                                    :canEdit="!readOnly" />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col>
                                <ObservateValueRegister
                                    :readOnly=readOnly
                                    :target=1
                                    :observateItemValues="editItems.observateItemValues"
                                    :observateItems="observateItems"
                                    />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col>
                                <v-text-field 
                                    v-model="editItems.memo" 
                                    clearable 
                                    label="メモ" 
                                    outlined 
                                    type="text" 
                                    counter="50"
                                    :readonly=readOnly
                                    :rules="[validatorMemoLength]" />
                            </v-col>
                        </v-row>
                    </v-form>
                    <!-- 編集/表示兼用の画像一覧 -->
                    <v-row align="center" justify="start" dense no-gutters>
                        <div v-for="image in editItems.images" :key="image.no">
                            <v-col v-if="image.state != 3" class="pt-0 pr-0 pl-0">
                                <div @click="onClickImage(image)" style="width:200px;" class="mr-3">
                                    <div style="position: relative; width: 200px; height: 200px; background-color:gray">
                                        <v-img
                                            v-if="image.state == 4"
                                            style="position:absolute; top:0px; left:0px; width:100%; height:100%"
                                            :src="image.image" 
                                            max-width="200"
                                            max-height="200"
                                            aspect-ratio="1">
                                        </v-img>
                                        <v-img
                                            v-if="image.state == 2"                                        
                                            style="position:absolute; top:0px; left:0px; width:100%; height:100%"
                                            :src="image.image" 
                                            max-width="200"
                                            max-height="200"
                                            aspect-ratio="1">
                                        </v-img>
                                        <v-img
                                            v-if="image.state == 1"                                        
                                            style="position:absolute; top:0px; left:0px; width:100%; height:100%"
                                            :src="image.url" 
                                            max-width="200"
                                            max-height="200"
                                            aspect-ratio="1">
                                        </v-img>
                                        <template v-for="comment in image.comments">
                                            <v-img
                                                v-if="comment.visible"
                                                :key="comment.dateTime"
                                                :src="comment.image"
                                                style="position:absolute; top:0px; left:0px; width:100%; height:100%"
                                                max-width="200"
                                                max-height="200"
                                                aspect-ratio="1" />
                                        </template>
                                    </div>
                                        
                                    <v-btn icon color="primary" @click.stop="onClickCommentToImage(image)"><v-icon large>mdi-comment-edit-outline</v-icon></v-btn>
                                    <v-btn icon color="primary" @click.stop="onClickDeleteImage(image)"><v-icon large>mdi-delete-circle-outline</v-icon></v-btn>
                                </div>
                            </v-col>
                        </div>
                    </v-row>
                    <v-row v-if="!readOnly">
                        <v-col>
                            <ImageImporter @onImportedImage="onImportedImage" @onImportedUncategorizedImages="onImportedUncategorizedImages" enabledUncategorizedImageSelect/>
                        </v-col>
                    </v-row>
                    <ImageViewer ref="imageViewer" />
                </v-container>
                <!-- コメント -->
                <div v-if="targetObservate != null">
                    <v-divider class="mb-2" />
                    <div v-for="comment in comments" :key="comment.body.commentNo">
                        <div class="d-flex flex-no-wrap">
                            <v-avatar class="ml-2" rounded>
                                <v-img v-if="comment.writer.avaterURL == null" src="@/assets/no_avater_image.png"/>
                                <v-img v-if="comment.writer.avaterURL != null" :src="comment.writer.avaterURL"/>
                            </v-avatar>
                            <div class="balloon2-left" style="margin-top:0px; margin-right:10px; width:100%">
                                <v-card-text class="pa-1">
                                    <div class="subtitle-2 font-weight-bold mb-1">{{comment.writer.userName}}</div>
                                    <div class="body-2 mb-1" v-html="comment.body.comment.replace(/\r?\n/g, '<br>')" />
                                    <div class="caption">{{comment.body.writer.dateTime}}</div>
                                </v-card-text>
                                    <!-- <span class="subtitle-2 font-weight-bold mb-1">{{comment.writer.userName}}</span>
                                    <span class="body-2 mb-1" v-html="comment.body.comment.replace(/\r?\n/g, '<br>')" />
                                    <span class="caption">{{comment.body.writer.dateTime}}</span> -->
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-no-wrap">
                        <v-avatar class="ml-2" rounded>
                            <v-img v-if="userData.avaterImage != null" :src="userData.avaterImage.url" />
                            <v-img v-if="userData.avaterImage == null" src="@/assets/no_avater_image.png"/>
                        </v-avatar>
                        <v-textarea
                            v-model="comment"
                            label="コメント"
                            rows="2"
                            clearable
                            solo
                            flat
                            auto-grow
                            hide-details
                            dense
                            class="mt-2 balloon2-left mr-2"
                            :append-icon="comment != null && comment.trim().length > 0 ? 'mdi-send' : ''"
                            @click:append="onClickSendNewComment">
                        </v-textarea>
                        <!-- <v-textarea
                            v-model="comment"
                            label="コメント"
                            rows="2"
                            outlined
                            clearable
                            auto-grow
                            hide-details
                            dense
                            class="mt-2">
                        </v-textarea> -->
                        <!-- <v-btn color="primary" @click="onClickSendNewComment" :disabled="comment.trim().length == 0" class="mt-1 mb-1">投稿する</v-btn> -->
                    </div>
                </div>
            </v-card-text>
        </v-card>
        <Confirm ref="confirm" />
        <ImageEditor ref="imageEditor" @onAddImageComment="onAddImageComment" />
    </v-dialog>
</template>
<script>
    import fb from '@/firebase/firebase.js'
    import db from '@/firebase/firestore.js'
    import Confirm from '@/components/tools/ConfirmDialog';
    import DatePicker from '@/components/tools/DatePicker';
    import ImageImporter from '@/components/tools/ImageImporter';
    import ImageViewer from '@/components/tools/ImageViewer';
    import ImageEditor from '@/components/tools/ImageEditorDialog';
    import TitleButton from '@/components/tools/TitleBarButton';
    import ObservateValueRegister from '@/components/seedling/items/ObservateValueRegister';
    export default {
        props: {
            readOnly: {type: Boolean, default: false}
        },
        components: {
            ObservateValueRegister,
            ImageImporter,
            ImageViewer,
            ImageEditor,
            TitleButton,
            DatePicker,
            ObservateValueRegister,
            Confirm
        },
        computed: {
            userData: function () {
                return this.$store.getters["userData"]
            }
        },
        data: function () {
            return {
                isView: false,
                targetSeedling: null,   // 観察対象の苗
                targetObservate: null,  // 編集対象観察データ(新規の時は、null)
                editItems: {
                    date: "",
                    observateItemValues: [],    // 観察項目値 {id, value}
                    memo: "",
                    images: [],
                },
                selectingImage: null,
                observateItems: [],         // 登録されている全観察項目
                registeredObservates: [],   // 観察対象の苗の全観察データ
                comments: [],
                comment: "",
                validatorMemoLength: value => value.length <= 50 || '50文字以内で入力して下さい。',
            }
        },
        methods: {
            // =====================================================
            // 保存ボタン押下時
            onClickSave: function () {
                const self = this

                if (this.targetObservate == null || this.targetObservate.date != this.editItems.date) {
                    const index = this.registeredObservates.findIndex((v)=>v.date == this.editItems.date)
                    if (index >= 0) {
                        this.$refs.confirm.show({
                            title: "入力エラー",
                            message: "指定された作業日に既に観察データが登録されています。<br/>同じ作業日で複数の観察データは登録出来ません。",
                            width: 500,
                            buttonYes: "入力に戻る",
                            buttonNo: "",
                        })
                        return
                    }
                }

                console.log(this.editItems.observateItemValues)

                if (this.editItems.observateItemValues.findIndex((v)=>v.value == null) >= 0){
                    this.$refs.confirm.show({
                        title: "保存",
                        message: "観察データに値が設定されていない項目があります。<br/>このまま登録しますか？",
                        buttonYes: "登録する",
                        buttonNo: "いいえ",
                        width: 500,
                        listenerYes: function () {
                            if (self.editItems.images.length > 0) {
                                self.imageUploader(self.register)
                            } else {
                                self.register()
                            }
                            return true
                        },
                    })
                } else {
                    self.$refs.confirm.show({
                        title: "保存",
                        message: "観察データを登録しますか？",
                        buttonYes: "登録する",
                        buttonNo: "いいえ",
                        width: 400,
                        listenerYes: function () {
                            if (self.editItems.images.length > 0) {
                                self.imageUploader(self.register)
                            } else {
                                self.register()
                            }
                            return true
                        },
                    })
                }
            },
            // =====================================================
            // 画像押下時
            onClickImage: function (image) {
                console.log(image)
                this.$refs.imageViewer.show(image)
            },
            // =====================================================
            // 画像へのコメントボタン押下時
            onClickCommentToImage: function (image) {
                console.log(image)
                const editorParams = {
                    originalImage: image,
                    title: "画像へのコメント記入",
                    baseImage: "",
                    layers: [],
                    readOnly: false,
                    canAddLayer: false,
                    createNewLayerWhenStart: true,
                }
                if (image.url != "") {
                    editorParams.baseImage = image.url
                } else if (image.image != "") {
                    editorParams.baseImage = image.image
                }
                for (var i=0; i<image.comments.length; i++) {
                    console.log(image.comments[i], image.comments[i].visible)
                    const layer = {
                        srcImage: image.comments[i].image,
                        visible: image.comments[i].visible,
                        name: image.comments[i].dateTime,
                        canDelete: true,
                        canEdit: true,
                        commentData: image.comments[i]
                    }
                    console.log(layer)
                    editorParams.layers.push(layer)
                }
                console.log(editorParams)
                this.$refs.imageEditor.show(editorParams)
            },
            // =====================================================
            // 画像の削除ボタン押下時
            onClickDeleteImage: function (image) {
                const self = this
                this.$refs.confirm.show({
                    title: "削除",
                    message: "この写真を削除して宜しいですか？",
                    width: 400,
                    icon: "mdi-alert",
                    buttonYes: "削除する",
                    buttonNo: "しない",
                    listenerYes: function () {
                        switch (image.state) {
                            case 1:
                                image.state = 3
                                break
                            case 2:
                                const index = self.editItems.images.findIndex((v) => v.no === image.no)
                                self.editItems.images.splice(index, 1)
                                break
                        }
                        return true
                    },
                })
            },
            // =====================================================
            // コメント投稿ボタン押下時
            onClickSendNewComment: function () {
                const self = this
                this.$refs.confirm.show({
                    title: "投稿",
                    message: "この観察データへのコメントを投稿しますか？",
                    width: 400,
                    buttonYes: "投稿する",
                    buttonNo: "しない",
                    listenerYes: function () {
                        self.registComment()
                        return true
                    },
                })
            },
            // =====================================================
            // 画像へのコメント記入時
            onAddImageComment: function (params) {
                console.log("onAddImageComment", params)
                const self = this
                params.originalImage.comments = []
                params.layers.forEach(function(layer){
                    const commentData = {
                        version: "1.0.0",
                        image: layer.image,
                        visible: layer.params.visible,
                        dateTime: "",
                        userUID: self.$store.getters["userUID"]
                    }
                    if (layer.params.commentData != null) {
                        commentData.dateTime = layer.params.commentData.dateTime
                    } else {
                        commentData.dateTime = self.df_currentDateTime()
                    }
                    console.log(commentData)
                    params.originalImage.comments.splice(0, 0, commentData) //.push(commentData)
                })
            },

                // for (var i=0; i<image.comments.length; i++) {
                //     targetImage.comments.push(
                //         {
                //             version: "1.0.0",
                //             image: image.comments[i].image,
                //             visible: image.comments[i].visible,
                //             dateTime: image.comments[i].dateTime,
                //             userUID: this.userUID
                //         }
                //     )
                // }


            // =====================================================
            // 画像取り込み時(カメラorローカル)
            onImportedImage: function (image) {
                console.log("onImportedImage")
                var newNo = 1
                if (this.editItems.images.length > 0) {
                    newNo = Math.max(...this.editItems.images.map(m => m.no)) + 1
                }
                this.editItems.images.push({
                    no: newNo,
                    state: 2,
                    image: image,
                    url: "",
                    capturedDate: this.df_currentDateTime(),
                    comments: []
                })
                console.log(this.editItems)
            },
            // =====================================================
            // 未分類の撮影画像取り込み時
            onImportedUncategorizedImages: function (images) {
                console.log("onImportedUncategorizedImages", images)

                const self = this

                //　参考 >> https://hi0a.com/demo/-js/img-base64-datauri/
                const Base64Converter = function(){
                    // URLからファイルを取得
                    this.loadBinaryResource = function(url) {
                        var req = new XMLHttpRequest();
                        req.open('GET', url, false);
                        req.overrideMimeType('text/plain;charset=x-user-defined');
                        req.send(null);
                        if (req.status != 200) return '';
                        return req.responseText;
                    }
                
                    // バイナリデータを文字列に変換
                    this.convertBinaryFile = function(url) {
                        var filestream = this.loadBinaryResource(url);
                        var bytes = [];
                        for (var i = 0; i < filestream.length; i++){
                            bytes[i] = filestream.charCodeAt(i) & 0xff;
                        }
                        // const result = String.fromCharCode.apply(String, bytes);
                        var result = ""
                        for (var i=0; i<bytes.length; i++) {
                            result += String.fromCharCode(bytes[i])
                        }
                        return result
                    }
                
                    // バイト文字列をbase64文字列に変換
                    this.convertImgDataURL = function(url){
                        var binary_file = this.convertBinaryFile(url);
                        var base64 = btoa(binary_file);
                        var head = binary_file.substring(0,9);
                        var exe = this.checkExe(head);
                        return 'data:image/' + exe + ';base64,' + base64;
                    }
                
                    // バイナリの拡張子をチェック
                    this.checkExe = function(head){
                        if (head.match(/^\x89PNG/)) {
                            return 'png';
                        } else if (head.match(/^BM/)){
                            return 'bmp';
                        } else if (head.match(/^GIF87a/) || head.match(/^GIF89a/)) {
                            return 'gif';
                        } else if (head.match(/^\xff\xd8/)) {
                            return 'jpeg';
                        } else {
                            return false;
                        }
                    }
                }

                var newNo = 1

                if (this.editItems.images.length > 0) {
                    newNo = Math.max(...this.editItems.images.map(m => m.no)) + 1
                }

                const converter = new Base64Converter()

                images.forEach(function(image){
                    console.log("image", image)

                    // まだ取り込まれていないイメージか否かをチェックし、取り込まれていなければ取り込む
                    if (self.editItems.images.findIndex((v)=>v.state == 4 && v.source.imageID == image.imageID) < 0) {
                        const item = {
                            no: newNo,
                            state: 4,
                            image: converter.convertImgDataURL(image.image.url),
                            url: "",
                            capturedDate: image.image.capturedDateTime,
                            source: image,
                            comments: []
                        }

                        self.editItems.images.push(item)

                        newNo++
                    }
                })
            },
            // =====================================================
            // コメント登録と通知
            registComment: function () {
                console.log("registComment", this.targetSeedling, this.targetObservate)

                const self = this
                const userUID = this.$store.getters["userUID"]
                const docObservateData = db.collection("users").doc(userUID)
                                         .collection("seedlings").doc(this.targetSeedling.seedlingID)
                                         .collection("observates").doc(""+this.targetObservate.observateNo)

                var avaterURL = null

                const writerUserData = this.$store.getters["loggedInUserData"]
                const writerUserUID = this.$store.getters["loggedInUserUID"]

                if (writerUserData.avaterImage != null) {
                    avaterURL = writerUserData.avaterImage.url
                }

                const comment = {
                    version: "1.0.0",
                    commentNo: this.comments.length + 1,
                    target: 1,
                    targetKey: {
                        seedlingID: this.targetSeedling.seedlingID,
                        observateNo: this.targetObservate.observateNo,
                    },
                    writer: {
                        userUID: writerUserUID,
                        dateTime: this.df_currentDateTime()
                    },
                    comment: this.comment,
                }
                
                // console.log(comment)
                const batch = db.batch()
                batch.set(docObservateData.collection("comments").doc(""+comment.commentNo), comment)

                if (userUID != writerUserUID) {
                    const notificationParams = {
                        batch:batch,
                        to: {
                            userUID: userUID
                        },
                        sender: null,
                        content: {
                            type: 20,
                            title: "コメント",
                            message: "苗の観察記録に新しいコメントがあります。"
                        },
                        data: {
                            target: 1,
                            targetKey: comment.targetKey,
                        }                        
                    }
                    this.$store.commit("sendNotification", notificationParams)
                }
                batch.commit().then(function(){
                    self.comments.push(
                        {
                            body: comment,
                            writer: {
                                userName: writerUserData.userName,
                                avaterURL: avaterURL
                            }
                        }
                    )
                    self.comment = ""
                    self.$store.commit("notification", {message:"コメントを投稿しました。"})
                    console.log(self.comments)
                    console.log("comment send success")
                }).catch(function(error){
                    console.log("comment send error", error)
                    self.$store.commit("notification", {message:"コメントの投稿に失敗しました。", isError:true})
                })
            },
            // =======================================
            // 画像をアップロードもしくは削除
            // completed:処理終了後に呼び出すメソッド
            imageUploader: function (completed) {
                
                const userUID = this.$store.getters["userUID"]
                const self = this

                console.log(this.targetSeedling)

                var uploadedNum = 0

                this.editItems.images.forEach(function(image){

                    const filename = image.capturedDate.replace(/\-/g, '').replace(/:/g, '').replace(/ /g, '')
                    const uploadUrl = "images/users/" + userUID + "/seedlings/" + self.targetSeedling.seedlingID + "/" + filename
                    
                    var storage = fb.storage().ref()
                    var outputRef = storage.child(uploadUrl)

                    switch (image.state) {
                        case 1:
                            // ===============================
                            // 登録済みの画像
                            uploadedNum++
                            if (uploadedNum == self.editItems.images.length) {
                                completed()
                            }
                            break;
                        case 2:
                        case 4:
                            // ===============================
                            // 画像のアップロード
                            const startIndex = image.image.indexOf(",") + 1
                            outputRef.putString(image.image.substring(startIndex), 'base64').then(function(snapShot){
                                snapShot.ref.getDownloadURL().then (function(url){
                                    console.log("imageUploader", "upload success("+image.no+")", "download url", url)
                                    image.url = url
                                    uploadedNum++
                                    if (uploadedNum == self.editItems.images.length) {
                                        completed()
                                    }
                                }).catch(function(error){
                                    console.log("画像のURL取得失敗", error)
                                })
                            }).catch(function(error){
                                console.log("画像のアップロード失敗", error)
                            })
                            break;
                        case 3:
                            // =======================================
                            // 画像の削除
                            outputRef.delete().then(function (){
                                console.log("RegisterObservation", "delete success("+image.no+")")
                                uploadedNum++
                                if (uploadedNum == self.editItems.images.length) {
                                    completed()
                                }
                            }).catch(function(error){
                                console.log("画像の削除失敗", error)
                            })
                            break;
                    }
                })
            },
            // =======================================
            // 登録処理
            register: function () {
                const userUID = this.$store.getters["userUID"]
                const self = this
                var observate = null

                if (this.targetObservate == null) {
                    observate = {
                        version: "1.0.0",
                        seedlingID: this.targetSeedling.seedlingID,
                        seedlingPlace: {
                            place: this.targetSeedling.placeHistories[this.targetSeedling.placeHistories.length - 1].place,
                            date: this.targetSeedling.placeHistories[this.targetSeedling.placeHistories.length - 1].date,
                        },
                        observateNo: this.targetSeedling.results.observatedNum + 1,
                        date: this.editItems.date,
                        values: [],
                        memo: this.editItems.memo,
                        images: [],
                        register: {
                            userUID: userUID,
                            dateTime: this.df_currentDateTime()
                        },
                        updater: {
                            userUID: "",
                            dateTime: ""
                        }
                    }
                } else {
                    observate = this.targetObservate
                    observate.date = this.editItems.date
                    observate.updater = {
                        userUID: userUID,
                        dateTime: this.df_currentDateTime()
                    }
                    observate.values = []
                    observate.images = []
                }

                for(var i=0; i<this.editItems.observateItemValues.length; i++) {
                    observate.values.push(this.editItems.observateItemValues[i])
                }

                for(var i=0; i<this.editItems.images.length; i++) {
                    const image = this.editItems.images[i]
                    switch(image.state) {
                        case 1:
                        case 2:
                        case 4:
                            const imageData = {
                                version: "1.0.0",
                                url: image.url,
                                capturedDate: image.capturedDate,
                                comments: []
                            }
                            observate.images.push(imageData)
                            for (var j=0; j<image.comments.length; j++) {
                                const comment = image.comments[j]
                                imageData.comments.push({
                                    version: "1.0.0",
                                    image: comment.image,
                                    visible: comment.visible,
                                    dateTime: comment.dateTime,
                                    userUID: userUID
                                })
                            }
                            break;
                        case 3:
                            break;
                    }
                }

                console.log("観察データ", observate)

                var batch = db.batch()

                // 観察データ
                batch.set(db.collection("users").doc(userUID).collection("seedlings").doc(observate.seedlingID).collection("observates").doc(""+observate.observateNo), observate)

                // 苗が持つ観察数更新(新規登録時のみ)
                if (this.targetObservate == null) {
                    this.targetSeedling.results.observatedNum += 1
                    this.targetSeedling.results.updater = {
                        userUID: userUID,
                        dateTime: this.df_currentDateTime()
                    }
                    batch.update(
                        db.collection("users").doc(userUID).collection("seedlings").doc(this.targetSeedling.seedlingID),
                        {
                            "results.observatedNum": this.targetSeedling.results.observatedNum,
                            "updater": this.targetSeedling.results.updater
                        }
                    )
                }
                
                // コミット
                batch.commit().then(function(){
                    self.$store.commit("notification", {message:"苗の観察データを登録しました。"})
                    if (self.targetObservate == null) {
                        self.$emit("onRegisteredSeedlingObservate", {
                            seedling: self.targetSeedling,
                            observate: observate
                        })
                    }
                    // 未分類から画像を取り込んだ時は、その画像を未分類から削除する
                    self.editItems.images.forEach(function(image){
                        if (image.state == 4) {
                            // ストレージから画像を削除
                            var storage = fb.storage().ref()
                            var outputRef = storage.child("images/users/"+userUID+"/uncategorized_images/"+image.source.imageID)
                            outputRef.delete().then(function(){
                                // ストレージから画像を削除後、DBから削除
                                db.collection("users").doc(userUID).collection("uncategorized_images").doc(image.source.imageID).delete().then(function(){
                                    console.log("uncategorized image deleted")
                                }).catch (function(error){
                                    console.log("uncategorized image delete failed!!(DB)", error)
                                })
                            }).catch(function (error) {
                                console.log("uncategorized image delete failed!!(Storage)", error)
                            })
                        }
                    })
                    self.isView = false
                }).catch (function (error) {
                    console.log(error)
                    self.$store.commit("notification", {message:"苗の観察データの登録に失敗しました。", isError:true})
                })
            },
            showFromNotification: function (key) {
                const self = this
                const userUID = this.$store.getters["userUID"]

                const docSeedling = db.collection("users").doc(userUID).collection("seedlings").doc(key.seedlingID)
                docSeedling.get().then(function(seedling){
                    const targetSeedling = seedling.data()
                    docSeedling.collection("observates").doc(""+key.observateNo).get().then(function(observate){
                        const targetObservate = observate.data()
                        self.show(targetSeedling, null, targetObservate)
                    })
                })
            },
            // =======================================
            // 表示
            show: async function (targetSeedling, registeredObservates, targetObservate) {
                this.targetSeedling = targetSeedling
                this.targetObservate = targetObservate
                this.registeredObservates = registeredObservates

                console.log(targetSeedling, registeredObservates, targetObservate)

                const self = this
                const userUID = this.$store.getters["userUID"]

                // ====================
                // 必須観察項目の設定
                var requiredItemSetter = function () {
                    self.observateItems.forEach(function(item) {
                        if (item.isRequired && (item.target == 0 || item.target == 1)) {
                            if (self.editItems.observateItemValues.findIndex((v)=>v.id == item.id) < 0) {
                                self.editItems.observateItemValues.push(
                                    {
                                        id: item.id,
                                        value: null
                                    }
                                )
                            }
                        }
                    })
                }

                // ====================
                // 初期化
                // 初期化終了後、必須観察項目の設定
                var initializer = function () {
                    self.editItems.images = []
                    
                    self.editItems.observateItemValues = []

                    if (self.targetObservate == null) {
                        self.editItems.date = self.df_currentDateTime("yyyy-MM-dd")
                        self.editItems.memo = ""
                        requiredItemSetter()
                    } else {
                        self.editItems.date = self.targetObservate.date
                        self.editItems.memo = self.targetObservate.memo
                        for (var i=0; i<self.targetObservate.values.length; i++) {
                            const value = self.targetObservate.values[i]
                            self.editItems.observateItemValues.push(
                                {
                                    id: value.id,
                                    value: value.value
                                })
                        }
                        self.targetObservate.images.forEach(function(image, index){
                            const imageData = {
                                no: index+1,
                                state: 1,
                                image: "",
                                url: image.url,
                                capturedDate: image.capturedDate,
                                comments: []
                            }
                            self.editItems.images.push(imageData)
                            if (image.comments == null) {
                                image.comments = []
                            }
                            image.comments.forEach(function (comment) {
                                console.log(comment)
                                imageData.comments.push(
                                    {
                                        image: comment.image,
                                        visible: comment.visible,
                                        dateTime: comment.dateTime,
                                        userUID: comment.userUID
                                    }
                                )
                            })
                        })
                        requiredItemSetter()
                    }

                    self.isView = true
                }

                // ====================
                // 観察項目取得
                // システムプリセットの観察項目を取得した後、ユーザー追加の観察項目を取得
                // 取得処理終了で、初期化処理を呼び出し
                this.observateItems = []
                
                const userObservateItemsGetter = async function () {
                    await db.collection("users").doc(userUID)
                        .collection("managements").doc("observate")
                        .collection("observate_items").orderBy("order", "asc").get().then(function(snapShot){
                        if (snapShot.size == 0) {
                            initializer()
                        } else {
                            var setNum = 0
                            snapShot.forEach(function(doc){
                                const item = doc.data()
                                self.observateItems.push(item)
                                console.log("user observate item", item)
                                setNum++
                                if (setNum == snapShot.size) {
                                    initializer()
                                }
                            })
                        }
                    })
                }

                await db.collection("system").doc("template").collection("observate_items").where("target", "==", 1).get().then(function(snapShot){
                    if (snapShot == 0) {
                        userObservateItemsGetter()
                    } else {
                        snapShot.forEach(function(doc){
                            const item = doc.data()
                            self.observateItems.push(item)
                            console.log("system observate item", item)
                            if (self.observateItems.length == snapShot.size) {
                                userObservateItemsGetter()
                            }
                        })
                    }
                })

                // ====================
                // 登録されている全てのコメントを取得
                this.comments = []
                if (targetObservate != null) {
                    db.collection("users").doc(userUID)
                    .collection("seedlings").doc(targetSeedling.seedlingID)
                    .collection("observates").doc(""+targetObservate.observateNo)
                    .collection("comments").get().then(function(snapShot){
                        snapShot.forEach(function(doc){
                            var comment = {
                                body: doc.data(),
                                writer: {
                                    userName: "",
                                    avaterURL: ""
                                }
                            }
                            self.mi_userData(comment.body.writer.userUID, comment.writer)
                            self.comments.push(comment)
                        })
                    })
                }

            },
        }
    }
</script>

<style scoped>
    .balloon2-left {
        position: relative;
        display: inline-block;
        margin: 1.5em 0 1.5em 15px;
        padding: 0px 10px;
        min-width: 120px;
        max-width: 100%;
        color: #555;
        font-size: 16px;
        background: #FFF;
        border: solid 3px #555;
        border-radius: 8px;
        box-sizing: border-box;
    }

    .balloon2-left:before {
        content: "";
        position: absolute;
        top: 24px;
        left: -22px;
        margin-top: -12px;
        border: 12px solid transparent;
        border-right: 12px solid #FFF;
        z-index: 2;
    }

    .balloon2-left:after {
        content: "";
        position: absolute;
        top: 24px;
        left: -28px;
        margin-top: -14px;
        border: 14px solid transparent;
        border-right: 14px solid #555;
        z-index: 1;
    }

    .balloon2-left p {
        margin: 0;
        padding: 0;
    }
</style>
